export default __webpack_public_path__ + "0fd436ffff1c0ea02c103fd8cb52d07e.svg";